module.exports = __webpack_public_path__ + "static/media/cross.bcc99eef.svg";